<template>
  <div class="jin-form-work">
    <el-form v-for="(form, i) in info.formList" :ref="(info.template + i)" :key="i" class="el-form-flex el-form-reduce" :model="form" :rules="info.rules">
      <Delete :fix-con="{type: 'online', tem: info, idx: i}" />
      <div class="title jin-m">
        <h3>工作经历</h3>
      </div>
      <Input v-model="form.company_name" label="公司名称" prop="company_name" />
      <Input v-model="form.job" label="职位" prop="job" />
      <Select v-model="form.job_type" :options="info.job_type" label="岗位性质" prop="job_type" />
      <Date v-model="form.date" label="起止时间" prop="date" />
      <Input v-model="form.description" placeholder="简单描述你的工作职责，让我们快速了解你的能力" type="textarea" label="工作描述" prop="description" />
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      time: []
    }
  },
  created() {

  },
  methods: {
    submitForm() {
      const status = []
      let curr = true

      this.info.formList.forEach((item, i) => {
        this.$refs[(this.info.template + i)][0].validate((valid) => {
          status.push(valid)
          if (status.length === this.info.formList.length) curr = status.every(item => item)
        })
      })
      return curr
    },
    resetForm() {
      this.info.formList.forEach((item, i) => {
        this.$refs[(this.info.template + i)][0].resetFields()
      })
      this.info.formList = []
    }
  }
}
</script>

<style lang="scss" scoped>
.jin-pc {
  /deep/ .el-form-item__label {
    text-align: left;
  }

  .jin-input {
    width: 320px;
  }

  /deep/ .el-textarea {
    width: 670px;

    &__inner {
      min-height: 140px !important;
    }
  }
}

.jin-m {
  .jin-form-work {
    padding: 13px 0;
  }
}
</style>
